import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  templateUrl: './button.component.html',
  imports: [
    NgClass
  ],
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() variant: 'primary' | 'outline' | 'danger' | 'neutral' | 'ghost' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() width: string = ''; // Example: '200px', '100%', 'auto'
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() iconClass: string = ''; // Example: 'fa-solid fa-user'
  @Input() selected: boolean = false;
  @Output() clicked = new EventEmitter<void>();

  onClick() {
    this.clicked.emit();
  }

  get sizeClass() {
    return {
      sm: 'btn-sm py-1 px-3 text-sm',
      md: 'py-2 px-4 text-base md',
      lg: 'btn-lg py-3 px-4 text-lg'
    }[this.size];
  }

  get computedVariant(): string {
    if (this.selected) return 'btn-primary';

    switch (this.variant) {
      case 'outline':
        return 'btn-outline btn-outline-primary btn-outline-${this.color} btn-active-primary';
      case 'danger':
        return 'btn-danger';
      case 'neutral':
        return 'btn-light';
      case 'ghost':
        return 'btn-light-primary btn-active-light-primary';
      default:
        return 'btn-primary btn-hover-primary';
    }
  }
}
